// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__dvkIU","main1":"Footer_main1__NJ2uV","main2":"Footer_main2__ofHdv"};